(function (themeCurrency) {
  const productTagsElement = document.querySelector("#product-tags");
  const customerTagsElement = document.querySelector("#customer-tags");  
  let productTags = [];
  let customerTags = [];
  const partnerUserDiscount = 0.3;
  const qualifiedConsultantDiscount = 0.5;
  let customerDiscount = 0;
  let discountEligible = false;

  // Check if product is discount eligible based on product tags 
  if (productTagsElement.innerHTML) {
    productTags = JSON.parse(productTagsElement.innerHTML);
    discountEligible = productTags.includes("Not Discount Eligible") ? false : true;
  }
  
  // Apply appropriate discount based on customer tags   
  if (customerTagsElement.innerHTML) {
    customerTags = JSON.parse(customerTagsElement.innerHTML);
    customerDiscount = customerTags.includes("partner_user") && customerTags.includes("qualified_consultant") ? qualifiedConsultantDiscount : customerTags.includes("partner_user") ? partnerUserDiscount : 0; 
  }
  
  // Functions
  const convertToNum = (money) => {
    const moneyNumber = parseFloat(money.replace("$", ""));
    return moneyNumber;
  }
  
  const applyDiscount = (price, discount) => {
    const discountedPrice = (price * (1 - discount)).toFixed(2) * 100
    return discountedPrice;
  }
  
  const getPrices = () => {setTimeout(() => {
    const price = document.querySelector("#rc-radio1 + .rc-radio__label .price-label");
    const subscribePrice = document.querySelector("#rc-radio2 + .rc-radio__label .price-label");
    let count = 0;

    // count prevents endless control flow
    if (price && count < 5) {
        const discountedPrice = applyDiscount(
            convertToNum(price.innerText),
            customerDiscount
        );
        const discountedSubscribePrice = applyDiscount(
            convertToNum(subscribePrice.innerText),
            customerDiscount
        );

        price.innerText = themeCurrency.formatMoney(
            discountedPrice,
            theme.moneyFormat
        );
        subscribePrice.innerText = themeCurrency.formatMoney(
            discountedSubscribePrice,
            theme.moneyFormat
        );
    } else {
        getPrices();
        count += 1;
    }

  }, 100)};

  if (discountEligible && customerDiscount > 0) {
    document.addEventListener("DOMContentLoaded", getPrices());
  }
    
})(themeVendor.themeCurrency);